import z from "zod";

export const threeDModelDataProcessingErrorTypeValues = [
  "COMPONENT_NOT_FOUND",
  "HOST_FACE_NOT_FOUND",
  "GUTTER_HAS_DOWNSPOUTS",
  "END_CLAMP",
  "DOWNSPOUT_SPACING",
  "NO_ELEVATION_BELOW",
  "NO_ROOM_FOR_RUN",
  "OPENING_IN_PATH",
] as const;

const threeDModelDataProcessingErrorTypeSchema = z.enum(threeDModelDataProcessingErrorTypeValues);
export const ThreeDModelDataProcessingErrorType = threeDModelDataProcessingErrorTypeSchema.enum;
export type ThreeDModelDataProcessingErrorType = z.infer<typeof threeDModelDataProcessingErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type ThreeDModelDataProcessingErrors =
  | {
      errorType: typeof ThreeDModelDataProcessingErrorType.COMPONENT_NOT_FOUND;
      data: { structureId: string; sourceId: string };
    }
  | {
      errorType: typeof ThreeDModelDataProcessingErrorType.HOST_FACE_NOT_FOUND;
      data: { structureId: string; hostFaceId: string };
    }
  | {
      errorType: typeof ThreeDModelDataProcessingErrorType.GUTTER_HAS_DOWNSPOUTS;
      data: { structureId: string; sourceId: string };
    }
  | {
      errorType:
        | typeof ThreeDModelDataProcessingErrorType.END_CLAMP
        | typeof ThreeDModelDataProcessingErrorType.DOWNSPOUT_SPACING
        | typeof ThreeDModelDataProcessingErrorType.NO_ELEVATION_BELOW
        | typeof ThreeDModelDataProcessingErrorType.NO_ROOM_FOR_RUN
        | typeof ThreeDModelDataProcessingErrorType.OPENING_IN_PATH;
      data: { structureId: string; hostFaceId: string };
    };

export const threeDModelDataProcessingErrorDetails = {
  [ThreeDModelDataProcessingErrorType.COMPONENT_NOT_FOUND]: {
    sentryDescription: "A geometry edit named a component the structure does not carry",
  },
  [ThreeDModelDataProcessingErrorType.HOST_FACE_NOT_FOUND]: {
    sentryDescription: "A geometry edit named a host face the structure does not carry",
  },
  [ThreeDModelDataProcessingErrorType.GUTTER_HAS_DOWNSPOUTS]: {
    sentryDescription: "A gutter removal was asked for while downspouts still hang on it",
  },
  [ThreeDModelDataProcessingErrorType.END_CLAMP]: {
    sentryDescription: "No downspout fits: the gutter is shorter than the outlet's end clamp",
  },
  [ThreeDModelDataProcessingErrorType.DOWNSPOUT_SPACING]: {
    sentryDescription: "No downspout fits: every spot is within spacing of another downspout",
  },
  [ThreeDModelDataProcessingErrorType.NO_ELEVATION_BELOW]: {
    sentryDescription: "No downspout fits: nothing within reach below the gutter",
  },
  [ThreeDModelDataProcessingErrorType.NO_ROOM_FOR_RUN]: {
    sentryDescription:
      "No downspout fits: a lower roof or the wall sits too close under the gutter for the run to turn in",
  },
  [ThreeDModelDataProcessingErrorType.OPENING_IN_PATH]: {
    sentryDescription: "No downspout fits: a window or door blocks every run",
  },
} as const satisfies Record<ThreeDModelDataProcessingErrorType, ErrorDetails>;
